import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserService } from '../user.service';
import { RoleType } from '../../types';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const requiredRoles = route.data['roles'] as RoleType[];

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const userRoles = userService.userInfo?.roles ?? [];

  if (!userRoles.length) {
    return false;
  }

  const hasRequiredRole = requiredRoles.some(role => userRoles.includes(role));

  return hasRequiredRole ? true : router.createUrlTree(['/access-denied']);
};
